import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Teams = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M15.9535 6.02326C15.9535 7.59093 14.7603 8.87992 13.2325 9.03159V8.04762C13.2325 7.0245 12.4031 6.19507 11.3799 6.19507H9.91166C9.90856 6.1382 9.90686 6.08092 9.90686 6.02326C9.90686 4.35356 11.2605 3 12.9302 3C14.5999 3 15.9535 4.35356 15.9535 6.02326Z"
      fill="currentColor"
    />
    <path
      d="M21.5349 6.96253C21.5349 8.11848 20.5978 9.05555 19.4419 9.05555C18.2859 9.05555 17.3489 8.11848 17.3489 6.96253C17.3489 5.80659 18.2859 4.86951 19.4419 4.86951C20.5978 4.86951 21.5349 5.80659 21.5349 6.96253Z"
      fill="currentColor"
    />
    <path
      d="M18.7368 18.8229C18.5975 18.8229 18.4604 18.8142 18.3258 18.7972C18.6579 18.0111 18.8334 17.144 18.8139 16.236V10.8896C18.8192 10.5636 18.7407 10.2554 18.5982 9.98572H21.1163C21.6044 9.98572 22 10.3814 22 10.8694V15.575C22 17.3688 20.5459 18.8229 18.7521 18.8229H18.7368Z"
      fill="currentColor"
    />
    <path
      d="M7.99927 18.4276H11.3798C12.403 18.4276 13.2324 17.5982 13.2324 16.5751V9.98572H16.9614C17.4436 9.99765 17.8251 10.3979 17.8139 10.8801V16.2471C17.8813 19.1412 15.5916 21.5428 12.6977 21.6136C10.5774 21.5617 8.7815 20.2588 7.99927 18.4276Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.85255 7.19507H11.38C11.8508 7.19507 12.2325 7.57677 12.2325 8.04762V16.5751C12.2325 17.0459 11.8508 17.4276 11.38 17.4276H2.85255C2.3817 17.4276 2 17.0459 2 16.5751V8.04762C2 7.57677 2.38171 7.19507 2.85255 7.19507ZM9.30432 10.6759V9.6759H4.80432V10.6759H6.55432V15.1759H7.55432V10.6759H9.30432Z"
      fill="currentColor"
    />
  </Icon>
));

export default Teams;
